import {
    Component, Prop, Mixins,
} from 'vue-property-decorator';

@Component
/**
 * Slideshow Props
 */
export default class Props extends Mixins() {
    /**
     * Classes
     */
    @Prop() classes!: string | Array<string>;

    /**
     * Color of slideshow
     */
    @Prop({ type: String }) color!: string;

    /**
     * Slideshow Height
     */
    @Prop({ default: '75vh' }) height!: string | number;

    /**
     * Set slideshow height automatically
     */
    @Prop({ type: Boolean }) autoHeight!: boolean;

    /**
     * Slideshow Lazy Loading Images
     */
    @Prop({ type: Boolean }) lazy!: boolean;

    /**
     * Space between slides
     */
    @Prop({ default: 0 }) spaceBetween!: string | number;

    /**
     * Slides shown per view
     */
    @Prop({ default: 'auto' }) slidesPerView!: string | number;

    /**
     * Slides shown in columns
     */
    @Prop({ default: 1 }) slidesPerColumn!: string | number;

    /**
     * Enable loop through slides
     */
    @Prop({ type: Boolean }) loop!: boolean;

    /**
     * Transition effects
     */
    @Prop({ default: 'slide' }) effect!: string;

    /**
     * Slideshow direction
     */
    @Prop({ default: 'horizontal' }) direction!: string;

    /**
     * Controls Pagination type
     */
    @Prop() pagination!: string | number;

    /**
     * Controls Pagination background
     */
    @Prop({ type: Boolean }) paginationNoBg!: boolean;

    /**
     * Controls navigation type
     */
    @Prop({ default: '5' }) nav!: string | number;

    /**
     * Sets right nav icon
     */
    @Prop({ default: 'css-arrow' }) navRight!: string;

    /**
     * Sets left nav icon
     */
    @Prop({ default: 'css-arrow' }) navLeft!: string;

    /**
     * Controls slideshow auto-play
     */
    @Prop({ type: Boolean }) autoplay!: boolean;

    /**
     * Controls slideshow speed
     */
    @Prop({ default: '300' }) speed!: string;

    /**
     * Controls slideshow interval between changes
     */
    @Prop({ default: '5000' }) delay!: string;

    /**
     * Disables auto-play on interaction
     */
    @Prop({ type: Boolean }) disableOnInteraction!: boolean;

    /**
     * Other Swiper Options
     */
    @Prop({ default: () => {} }) otherOptions!: object;

    /**
     * Slide Items
     */
    @Prop({ type: Array }) slides!: Array<any>;

    /**
     * Version of the Images
     */
    @Prop({ type: String }) imageVersion!: string;

    /**
     * Put arrow on left side
     */
    @Prop({ type: Boolean }) leftArrow!: boolean;
}
